import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WarehouseService } from '../masterdata/Services/warehouse.service';
import { FranchiseeService } from '../services/franchisee.service';
import { AuthenticationService } from '../core/authentication.service';
import { LocalStorageKeyOptions, LocalStorageService } from '../core/local-storage.service';

@Component({
  selector: 'app-portal-landing',
  templateUrl: './portal-landing.component.html',
  styleUrls: ['./portal-landing.component.css']
})
export class PortalLandingComponent implements OnInit {

  isLoadingResults: boolean = false;
  portalList: any[] = [];
  warehouseList: any[] = [];
  franchiseeList: any[] = [];
  portal: any = {};
  returnUrl: string;

  constructor(
    private franchiseeApi: FranchiseeService,
    private warehouseApi: WarehouseService,
    private auth: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private local: LocalStorageService
  ) { }

  ngOnInit(): void {


    this.getWarehouseCollection();
    this.getFranchiseCollection();
  }

  getWarehouseCollection() {
    this.isLoadingResults = true;
    this.warehouseApi.GetWarehouseList().subscribe(data => {

      if (data.statusCode) {
        // this.warehouseList = data.result;
        data.result.forEach(element => {
          element.isWarehouse = true;
          this.warehouseList.push(element);
        });
      }
      this.isLoadingResults = false;
    }, err => {
      this.isLoadingResults = false;
    });
  }

  getFranchiseCollection() {
    this.isLoadingResults = true;
    this.franchiseeApi.getAllFranchises().subscribe(data => {
      if (data.statusCode) {
        // this.franchiseeList = data.result;
        data.result.forEach(element => {
          element.isFranchisee = true;
          this.franchiseeList.push(element);
        });
      }
      this.isLoadingResults = false;
    }, err => {
      this.isLoadingResults = false;
    });
  }

  onPortalSelect(data) {    
    
    if (data) {
      if (data.isWarehouse) {
        this.portal.WarehouseId = data.warehouseId;
        localStorage.setItem('isWarehouse', "Warehouse Portal");
        localStorage.setItem('title', data.title);
        localStorage.setItem('headerImage', data.flagUrl);
        localStorage.removeItem('isAZ');
        localStorage.removeItem('countryId');
        localStorage.removeItem('isAdmin');
        
      }

      if (data.isFranchisee) {
        if(data?.country?.countryCode == "AZ"){
          localStorage.setItem('isAZ', "AZ");
        }else{
          localStorage.getItem('isAZ') ? localStorage.removeItem('isAZ') : '';    
        }
        localStorage.setItem('countryId', data?.country?.countryId);
        localStorage.setItem('headerImage', data.flagUrl);
        this.portal.FranchiseId = data.franchiseId;
        localStorage.setItem('title', data.franchiseName);
        localStorage.removeItem('isWarehouse');
        localStorage.removeItem('isAdmin');
        
      }

    }
    else {
      localStorage.getItem('headerImage') ? localStorage.removeItem('headerImage') : '';
      localStorage.getItem('isAZ') ? localStorage.removeItem('isAZ') : '';
      localStorage.setItem('title', "");
      localStorage.removeItem('countryId');
      localStorage.removeItem('isWarehouse');
      localStorage.setItem('isAdmin', "admin");
    }
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || undefined;
    // this.local.setItem(LocalStorageKeyOptions.Title, data.title);

    this.auth.getPortalToken(this.portal).subscribe(data => {
      
      if (!this.returnUrl)
        this.returnUrl = '/dashboard';
      this.router.navigate([this.returnUrl]);
    },
      err => {
        this.toastr.error(err, 'Error');
        console.log(err);
        this.isLoadingResults = false;
      });
  }

  logout() {
    this.auth.logout().subscribe(data => {
      
      this.router.navigate(['/login']);
    }, err => {
      localStorage.clear();
      this.router.navigate(['/login']);
    });
  }


}
